<script lang="ts" setup>
interface Props {
  costs?: { perCompany: number, perRequest: number }
  description?: string
  endpoints?: { DELETE?: string[], GET?: string[], POST?: string[], PUT?: string[] }
  showActionsMenu?: boolean
  showCopyButton?: boolean
  title: string
}

const props = withDefaults(
  defineProps<Props>(),
  {
    showActionsMenu: true,
    showCopyButton: true,
  },
)

const endpointsList = computed(() => {
  return Object.entries(props.endpoints || {}).flatMap(
    ([method, paths]) => paths.map(
      path => ({
        method: method as ApiEndpointMethodMethod,
        path,
      }),
    ),
  )
})
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="relative flex flex-col gap-4 border-b border-gray-200 pb-4 dark:border-gray-800">
      <div class="flex flex-col gap-2">
        <h1 class="text-pretty text-3xl font-bold text-gray-900 sm:text-4xl dark:text-white">
          {{ title }}
        </h1>

        <div
          v-if="description"
          class="text-pretty text-lg text-gray-600 dark:text-gray-400"
        >
          <div>{{ description }}</div>
        </div>
      </div>

      <div
        v-if="endpointsList.length"
        class="flex flex-col gap-3"
      >
        <ApiEndpoint
          v-for="(endpoint, endpointIndex) of endpointsList"
          :key="endpointIndex"
          :costs="costs"
          :method="endpoint.method"
          :path="endpoint.path"
        />
      </div>
    </div>
  </div>
</template>
